module.exports = __webpack_public_path__ + "assets/img/f144724f35a029f9442c7d6a67be63a9.svg";